// Presentation only: keep the original origin ID for matching and data access.
const SOURCES = {
  "com.google.android.apps.fitness": "Google Fit",
  "com.sec.android.app.shealth": "Samsung Health",
  "com.huawei.health": "Huawei Health",
  "com.huawei.healthglobal": "Huawei Health",
  "com.fitbit.FitbitMobile": "Fitbit",
  "com.garmin.android.apps.connectmobile": "Garmin Connect",
  "com.garmin.connect.mobile": "Garmin Connect",
  "nl.appyhapps.healthsync": "Health Sync",
  "com.xiaomi.wearable": "Mi Fitness",
  "com.xiaomi.hm.health": "Zepp Life",
  "com.huami.watch.hmwatchmanager": "Zepp",
  "com.heytap.health": "OHealth",
  "com.strava": "Strava",
  "com.polar.polarflow": "Polar Flow",
  "com.suunto.app": "Suunto",
  "com.ouraring.oura": "Oura",
  "ch.wellcomefit.roody": "Roody",
}

export function healthSourceLabel(source) {
  const id = typeof source === "string" ? source : source?.sourceBundleId || source?.source || ""
  const name = typeof source === "object" ? source?.sourceName : source
  if (SOURCES[id]) return SOURCES[id]
  if (SOURCES[name]) return SOURCES[name]
  const label = typeof name === "string" ? name.trim().slice(0, 80) : ""
  return label && !/^[a-z][\w-]*(?:\.[\w-]+){2,}$/i.test(label) ? label : "Verbundene Health-App"
}

const measurement = value => typeof value === "number" && Number.isFinite(value) && value >= 0

export function healthWorkoutEnergy(execution, recording) {
  if (measurement(recording?.activeEnergyKilocalories)) return {
    value: recording.activeEnergyKilocalories, kind: "active", label: "Aktive Kalorien", source: healthSourceLabel(recording), estimated: false,
  }
  if (measurement(recording?.totalEnergyKilocalories)) return {
    value: recording.totalEnergyKilocalories, kind: "total", label: "Gesamtkalorien", source: healthSourceLabel(recording), estimated: false,
  }
  const watch = execution?.watchData?.health?.activeEnergyKilocalories
  if (measurement(watch)) return { value: watch, kind: "active", label: "Aktive Kalorien", source: "Roody Watch", estimated: false }
  const raw = execution?.caloriesBurned
  const fallback = raw !== null && raw !== undefined && raw !== "" ? Number(raw) : NaN
  return { value: Number.isFinite(fallback) && fallback >= 0 ? fallback : null, kind: "estimate", label: "Kalorien · geschätzt", source: "Roody", estimated: true }
}

export function healthActivityIcon(workout) {
  const type = `${workout?.activityFamily || ""} ${workout?.activityName || ""}`.toLowerCase()
  if (/strength|kraft|weight/.test(type)) return "mdi-dumbbell"
  if (/run|lauf/.test(type)) return "mdi-run"
  if (/walk|geh|wander/.test(type)) return "mdi-walk"
  if (/cycl|rad/.test(type)) return "mdi-bike"
  if (/swim|schwimm/.test(type)) return "mdi-swim"
  if (/yoga/.test(type)) return "mdi-yoga"
  return "mdi-motion-play-outline"
}
